import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      weekStartsOn={1}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-semibold text-slate-900",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          "h-7 w-7 bg-transparent p-0 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-sm inline-flex items-center justify-center transition-colors"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex w-full",
        head_cell:
          "text-slate-500 rounded-sm font-medium text-[11px] uppercase tracking-wide flex-1 text-center py-2",
        row: "flex w-full mt-1",
        cell: cn(
          "relative text-center text-sm focus-within:relative focus-within:z-20 flex-1 [&:has([aria-selected])]:bg-indigo-50 [&:has([aria-selected].day-outside)]:bg-indigo-50/50 first:[&:has([aria-selected])]:rounded-l-sm last:[&:has([aria-selected])]:rounded-r-sm",
          props.mode === "range"
            ? "[&:has(>.day-range-end)]:rounded-r-sm [&:has(>.day-range-start)]:rounded-l-sm"
            : "[&:has([aria-selected])]:rounded-sm"
        ),
        day: cn(
          "h-9 w-9 p-0 mx-auto font-normal text-slate-700 text-sm rounded-sm inline-flex items-center justify-center transition-colors hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:ring-offset-1 aria-selected:opacity-100"
        ),
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        day_selected:
          "bg-indigo-600 text-white hover:bg-indigo-600 hover:text-white focus:bg-indigo-600 focus:text-white font-medium",
        day_today: "ring-1 ring-inset ring-indigo-300 text-indigo-600 font-medium",
        day_outside:
          "day-outside text-slate-300 aria-selected:bg-indigo-50/50 aria-selected:text-slate-400",
        day_disabled: "text-slate-300",
        day_range_middle:
          "aria-selected:bg-indigo-50 aria-selected:text-indigo-900",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn("h-4 w-4", className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn("h-4 w-4", className)} {...props} />
        ),
      }}
      {...props} />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
